import { FormImageUploaderActionTypes, TFormImageUploaderAction } from './formImageUploaderActions';
import { IFormImageUploaderState } from './formImageUploaderContext';

export const formImageUploaderReducer = (
	state: IFormImageUploaderState,
	action: TFormImageUploaderAction,
): IFormImageUploaderState => {
	switch (action.type) {
		case FormImageUploaderActionTypes.SET_IMAGE_ORIENTATION:
			return {
				...state,
				imageOrientation: action.payload.imageOrientation,
			};
		case FormImageUploaderActionTypes.SET_LOADING:
			return {
				...state,
				isLoading: action.payload.isLoading,
			};
		case FormImageUploaderActionTypes.SET_FULL_SIZE_SRC:
			return {
				...state,
				fullSizeSrc: action.payload.src,
			};
		case FormImageUploaderActionTypes.SET_CROPPED_SIZE_SRC:
			return {
				...state,
				croppedSizeSrc: action.payload.src,
			};
		case FormImageUploaderActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case FormImageUploaderActionTypes.CHANGE_TYPE_OF_ERROR_MODAL_WINDOW:
			return {
				...state,
				typeOfErrorModalWindow: action.payload.typeOfErrorModalWindow,
			};
		case FormImageUploaderActionTypes.SET_LOADING_IMAGE_ERROR:
			return {
				...state,
				loadingImageError: action.payload.loadingImageError,
			};
		default:
			return state;
	}
};
